/*=========================================================================================
  File Name: moduleTodo.js
  Description: Todo Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTodoState.js';
import mutations from './moduleTodoMutations.js';
import actions from './moduleTodoActions.js';
import getters from './moduleTodoGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
